import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import "./PageCategory.scss";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  isMobileMatcheState,
  isUserRightsState
} from "../../../../../atoms/atom";
import PageSearch from "./PageSearch";
import { useQuery } from "react-query";
import {
  getLoungeSectionList,
  ILoungeSectionList
} from "../../../../../api/api";
import CategoryLoading from "../../../../common/loading/CategoryLoading";

function PageCategory() {
  const { t } = useTranslation();
  const { service_code, title } = useParams();
  const { isLoading, data } = useQuery<ILoungeSectionList>("list", () =>
    getLoungeSectionList(service_code || "")
  );
  const navigate = useNavigate();
  const setIsUserRights = useSetRecoilState(isUserRightsState);
  const isMobile = useRecoilValue(isMobileMatcheState);
  const [ulWidth, setUlWidth] = useState(0);

  const ulRef = useRef<any>(null);

  useEffect(() => {
    if (data?.result === 1) {
      for (let a = 0; a < data.data.length + 1; a++) {
        // console.log(
        //   ulRef.current?.childNodes[a].innerText,
        //   ulRef.current?.childNodes[a].offsetWidth
        // );
        setUlWidth((prev) => prev + ulRef.current?.childNodes[a].offsetWidth);
      }
    }
  }, [isLoading]);

  const allColor = title === undefined || title === "all" ? "on" : "";

  useEffect(() => {
    if (data?.result === 1) {
      setIsUserRights(data.data);
    }
  }, [data]);

  return isLoading ? (
    <CategoryLoading />
  ) : data?.result === 1 ? (
    <nav className="nav nav-header clearfix">
      <div className="category-wrapper">
        <ul
          className="clearfix"
          ref={ulRef}
          style={{ width: `${ulWidth + 200}px` }}
        >
          <>
            <li className={`lnb_cate ${allColor}`}>
              <Link to={`/page/${service_code}/all`}>
                <i className="icon board " />
                {t("all")}
              </Link>
            </li>
            {data?.data?.map((i) => (
              <li
                className={i.title === title ? "lnb_cate on" : "lnb_cate"}
                key={i.idx}
              >
                <Link to={`/page/${service_code}/${i.title}`}>
                  <i className="icon board" />
                  {t(i.lang_code)}
                </Link>
              </li>
            ))}
          </>
        </ul>
      </div>
      {isMobile && <PageSearch />}
    </nav>
  ) : (
    <>{navigate("/notfound", { replace: true })}</>
  );
}
const PageCategoryMemo = React.memo(PageCategory);
export default withTranslation()(PageCategoryMemo);
